import React from 'react';

const LineChart = ({ data, height = 150, title }) => {
  // Find min and max values for scaling
  const values = data.map(item => item.value);
  const maxValue = Math.max(...values);
  const minValue = Math.min(...values);
  const range = maxValue - minValue;
  
  // Calculate points for the SVG path
  const points = data.map((item, index) => {
    const x = (index / (data.length - 1)) * 100;
    const y = 100 - ((item.value - minValue) / (range || 1)) * 100;
    return `${x},${y}`;
  }).join(' ');
  
  // Create dots for the SVG
  const dots = data.map((item, index) => {
    const x = (index / (data.length - 1)) * 100;
    const y = 100 - ((item.value - minValue) / (range || 1)) * 100;
    return { x, y, value: item.value, label: item.label };
  });
  
  return (
    <div className="bg-white rounded-lg p-4 shadow">
      {title && <h3 className="font-medium mb-4">{title}</h3>}
      <div style={{ height: `${height}px` }} className="relative">
        <svg viewBox="0 0 100 100" className="w-full h-full overflow-visible">
          {/* X-axis */}
          <line x1="0" y1="100" x2="100" y2="100" stroke="#E5E7EB" strokeWidth="0.5" />
          
          {/* Y-axis */}
          <line x1="0" y1="0" x2="0" y2="100" stroke="#E5E7EB" strokeWidth="0.5" />
          
          {/* Line chart */}
          <polyline
            fill="none"
            stroke="#3B82F6"
            strokeWidth="2"
            points={points}
          />
          
          {/* Dots */}
          {dots.map((dot, index) => (
            <circle
              key={index}
              cx={dot.x}
              cy={dot.y}
              r="1.5"
              fill="#3B82F6"
              stroke="white"
              strokeWidth="1"
              className="cursor-pointer hover:r-2"
            />
          ))}
        </svg>
        
        {/* Labels */}
        <div className="flex justify-between mt-2">
          {data.map((item, index) => (
            <div key={index} className="text-xs text-gray-600">{item.label}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LineChart;